
import { createNamespacedHelpers } from 'vuex'
import menuItems from '~/components/pages/education/EducationMenu/menuItems.js'
const { mapGetters } = createNamespacedHelpers('education')

export default {
  name: 'EducationMenu',
  data() {
    return {
      menuItems,
      selectedMenuItem: {},
      isMenuOpen: false
    }
  },

  computed: {
    ...mapGetters({
      questionnairesCount: 'getActiveQuestionnairesCount',
      homeworksCounter: 'getHomeworksCounter'
    }),

    isMentor() {
      return this.$store.state.user.isMentor
    },

    firstBlock() {
      if (this.isMentor) return menuItems.firstBlock

      return menuItems.firstBlock.filter(item => item.label !== 'mentors')
    },

    secondBlock() {
      return menuItems.secondBlock
    },

    settingsItem() {
      return menuItems.settings
    },

    activeMenuItemsLength() {
      return [
        ...menuItems.firstBlock,
        ...menuItems.secondBlock,
        menuItems.settings
      ].reduce((prev, next) => (next.digit ? ++prev : prev), 0)
    }
  },

  async beforeMount() {
    await this.$store.dispatch('education/fetchQuestionnairesData')
    await this.$store.dispatch('education/getHomeworksCounters')
  },

  methods: {
    openMenu() {
      this.isMenuOpen = true
      document.body.style.overflow = 'hidden'
    },

    closeMenu() {
      if (this.isMenuOpen) {
        this.isMenuOpen = false
        document.body.style.overflow = ''

        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      }
    },

    checkIsSelected(item) {
      if (item && this.$route?.path === item.link) {
        this.selectedMenuItem = item

        return this.$route?.path === item.link
      }
    },

    getItemCounter(item) {
      if (item.label === 'questionnaires') {
        return this.questionnairesCount
      }

      if (item.label === 'homeworks') {
        return this.homeworksCounter
      }

      return item.digit
    }
  }
}
